import { gql } from '@apollo/client';

import META_FRAGMENT from '../fragments/meta';
import SERVICE_TYPES_FRAGMENT from '../fragments/services';

export const GET_SERVICE_TYPES = gql`
  ${SERVICE_TYPES_FRAGMENT}
  ${META_FRAGMENT}
  query findServiceTypes($pagination: PageOptionsDto, $order: ServiceTypeSortFields) {
    findServiceTypeEntity(pagination: $pagination, order: $order) {
      data {
        ...ServiceTypesFragment
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;

export const GET_ONE_SERVICE_TYPE = gql`
  ${SERVICE_TYPES_FRAGMENT}
  query findOneServiceTypeEntity($id: String) {
    findOneServiceTypeEntity(id: $id) {
      ...ServiceTypesFragment
    }
  }
`;
